import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { User } from '../../models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthAppService {
  private trinityLoggedUserSubject = new BehaviorSubject<User>(this.getSavedUser());
  public trinityLoggedUser = this.trinityLoggedUserSubject.asObservable().pipe(distinctUntilChanged());

  private wellBeingDetailSubject = new BehaviorSubject<any>(this.getWellbeingDetails());
  public wellBeingDetail = this.wellBeingDetailSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  private static readonly key_frontend = 'TRINITY_JWT_KEY';
  private static readonly key_backend = 'TRINITY_JWT_KEY_BACKEND';

  clientIdType: 'frontend' | 'backend' = 'frontend';

  get isLoggedIn(): boolean {
    try {
      return !!localStorage.getItem(AuthAppService.key_frontend);
    } catch (error) {
      return false;
    }
  }

  get isBackendLoggedIn(): boolean {
    try {
      return !!localStorage.getItem(AuthAppService.key_backend);
    } catch (error) {
      return false;
    }
  }

  clientType() {
    try {
      return localStorage.getItem('ClientType');
    } catch (error) {
      return 'frontend';
    }
  }

  getSavedUser() {
    try {
      const cuser = localStorage.getItem('trinityLoggedUser');
      if (cuser) {
        const trinityLoggedUser = JSON.parse(cuser);
        return trinityLoggedUser;
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  setAuth(token: string) {
    localStorage.setItem(AuthAppService.key_frontend, token);
    localStorage.setItem('ClientType', 'frontend');
    localStorage.setItem('trinityLastLogin', new Date().toString());
    this.isAuthenticatedSubject.next(true);
  }

  setBackendAuth(token: string) {
    localStorage.setItem(AuthAppService.key_backend, token);
    localStorage.setItem('ClientType', 'backend');
    localStorage.setItem('trinityLastLogin', new Date().toString());
  }

  getToken() {
    try {
      return localStorage.getItem(AuthAppService.key_frontend);
    } catch (error) {
      return '';
    }
  }

  getBackendToken() {
    try {
      return localStorage.getItem(AuthAppService.key_backend);
    } catch (error) {
      return '';
    }
  }

  setTrinityLoggedUser(user: User) {
    localStorage.setItem('trinityLoggedUser', JSON.stringify(user));
    localStorage.setItem('trinityLastLogin', new Date().toString());
    this.trinityLoggedUserSubject.next(user);
  }

  setWellbeingDetails(wellbeing: any) {
    localStorage.setItem('wellbeing', JSON.stringify(wellbeing));
    this.wellBeingDetailSubject.next(wellbeing);
  }

  getWellbeingDetails() {
    try {
      return JSON.parse(localStorage.getItem('wellbeing') || '{}');
    } catch (error) {
      return '{}';
    }
  }

  getTrinityLoggedUser(): User {
    return this.trinityLoggedUserSubject.value;
  }

  clearUserData() {
    localStorage.removeItem('trinityLoggedUser');
    localStorage.removeItem('trinityLastLogin');
    localStorage.removeItem('wellbeing');
    localStorage.removeItem('ClientType');
    localStorage.removeItem(AuthAppService.key_frontend);
    localStorage.removeItem(AuthAppService.key_backend);
  }

  purgeAuth() {
    // Remove token  from localstorage
    this.clearUserData();
    // Set current user to an empty object
    this.trinityLoggedUserSubject.next(new User());
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
    setTimeout(() => {
      localStorage.removeItem('trinityLastLogin');
    }, 100);
    return;
  }
}
